import React from "react";

/** One-line result banner for admin actions: { type: "success" | "error", text } or null. */
export default function RequestNotice({ notice, onDismiss }) {
  if (!notice) return null;
  const ok = notice.type === "success";
  return (
    <div
      role={ok ? "status" : "alert"}
      className={`mb-4 flex items-start justify-between gap-3 rounded-md px-4 py-3 text-sm ${
        ok ? "bg-green-50 text-green-800" : "bg-red-50 text-red-800"
      }`}
    >
      <span>{notice.text}</span>
      <button type="button" onClick={onDismiss} className="font-semibold underline">
        Dismiss
      </button>
    </div>
  );
}
